import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../../../api/query-keys';
import { useAuth } from '../../../auth/AuthProvider';
import { getMachineWorkspace } from './machine-memory.api';

export function useMachineMemory(machineId: string, enabled = true) {
  const auth = useAuth();
  return useQuery({
    queryKey: queryKeys.machineMemory(auth.activeCustomerId, machineId),
    queryFn: () => getMachineWorkspace(machineId),
    enabled: Boolean(enabled && auth.activeCustomerId && machineId),
    retry: false,
  });
}
